import noUiSlider from 'nouislider';
import wNumb from 'wnumb';

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = this.debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector("form");
    facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper)
      facetWrapper.addEventListener("keyup", this.onKeyUpEscape);

    this.filterDrawer = document.querySelector('[data-filter-drawer-section]');
    const filterDrawerCTA = document.querySelector('[data-filter-drawer-cta]');
    const filterDrawerClose = document.querySelectorAll('[data-filter-drawer-section] [drawer-close-button]');
    filterDrawerCTA.addEventListener('click', this.openFilterDrawer.bind(this));
    filterDrawerClose.forEach((element) => {
      element.addEventListener('click', this.closeFilterDrawer.bind(this));
    });
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();

    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.refreshAjaxinate();
        FacetFiltersForm.reinitSwipers();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
  }

  static renderProductGridContainer(html) {
    /* Collection Grid Switcher */
    if(document.querySelector('grid-view')) {
      const currentLayout = document.querySelector('grid-view button').dataset.layout;
      const parser = new DOMParser();
      const htmlElement = parser.parseFromString(html, "text/html");
      htmlElement.querySelector('#product-grid').setAttribute("data-layout", currentLayout);
      html = htmlElement.documentElement.innerHTML;
    }
    /* End Collection Grid Switcher */

    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;

    document
      .getElementById("ProductGridContainer")
      .querySelectorAll(".scroll-trigger")
      .forEach((element) => {
        element.classList.add("scroll-trigger--cancel");
      });
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const facetDetailsElements = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element)
    );
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`
      ).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);

    if (countsToRender)
      FacetFiltersForm.renderCounts(
        countsToRender,
        event.target.closest(".js-filter")
      );
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector(".facets__selected");
    const sourceElement = source.querySelector(".facets__selected");

    const targetElementAccessibility = target.querySelector(".facets__summary");
    const sourceElementAccessibility = source.querySelector(".facets__summary");

    if (sourceElement && targetElement) {
      target.querySelector(".facets__selected").outerHTML =
        source.querySelector(".facets__selected").outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector(".facets__summary").outerHTML =
        source.querySelector(".facets__summary").outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  debounce(func, timeout = 300) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, timeout);
    };
  }

  onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector("summary");
    openDetailsElement.removeAttribute("open");
    summaryElement.setAttribute("aria-expanded", false);
    summaryElement.focus();
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll(
      "facet-filters-form form"
    );
    if (event.srcElement.className == "mobile-facets__checkbox") {
      const searchParams = this.createSearchParams(
        event.target.closest("form")
      );
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile =
        event.target.closest("form").id === "FacetFiltersFormMobile";

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (
            form.id === "FacetSortForm" ||
            form.id === "FacetFiltersForm" ||
            form.id === "FacetSortDrawerForm"
          ) {
            const noJsElements = document.querySelectorAll(".no-js-list");
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === "FacetFiltersFormMobile") {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join("&"), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1
          );
    FacetFiltersForm.renderPage(url);
  }

  openFilterDrawer() {
    document.body.classList.add(window.Moonbase.classes.filterDrawerOpen);
  }

  closeFilterDrawer() {
    document.body.classList.remove(window.Moonbase.classes.filterDrawerOpen);
  }

  // Reinitialise swipers when page is re-rendered after facets are changed
  static reinitSwipers() {
    if(document.querySelector(".swiper-mobile")) {
      const swipers = document.querySelectorAll(".swiper-mobile");
      swipers.forEach((swiper) => {
        const parameters = JSON.parse(swiper.dataset.swiper);
        new window.Moonbase.Swiper(swiper, parameters);
      });
    }
  }

  static refreshAjaxinate() {
    const Moonbase = window.Moonbase || {};

    const thisAjaxinate = new Moonbase.Ajaxinate({
      container: ".ajaxinate",
      pagination: ".paginate-button",
      previousPagination: ".paginate-previous-button",
      loadingText: "Loading...",
      method: "click",
      callback: this.reinitSwipers
    });
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();

    switch(this.dataset.layout) {
      case "fields":
        this.querySelectorAll("input").forEach((element) =>
          element.addEventListener("change", this.onRangeChange.bind(this))
        );

        this.setMinAndMaxValues();
        break;
      case "checkboxes":
        this.selectors = this.querySelectorAll(".selector");
        this.onRangeClick = this.onRangeClick.bind(this);
        this.setEvents();
        break;
      case "slider":
        this.slider = this.querySelector('.noUiSlider-placeholder');
        this.min = Number(this.getAttribute('min'));
        this.max = Number(this.getAttribute('max'));
        this.currentValue = this.getAttribute('value');
        this.currencySymbol = this.getAttribute('symbol');
        this.minInput = this.querySelector('.js-range-min');
        this.maxInput = this.querySelector('.js-range-max');
        this.form = document.getElementById('FacetFiltersForm');

        if (!this.currencySymbol)
          this.currencySymbol = '£';

        if (!this.currentValue) {
          this.currentValue = [this.min, this.max];
        } else {
          const array = [];
          this.currentValue
              .split(',')
              .forEach(value =>
                  array.push(
                      Number(value)
                  )
              );
          this.currentValue = array;
        }

        this.slider = document.createElement('div');
        this.slider.classList.add('js-range-slider');

        this.prepend(this.slider);
        this.createNoUiSlider();
        this.setEventsSlider();

        break;
    }
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onRangeClick(event) {
    const range = event.target.closest(".range");
    const min = range.querySelector(".min");
    const max = range.querySelector(".max");

    if (event.target.checked) {
      document.querySelectorAll(".range").forEach((element) => {
        if (element.id != range.id) {
          element.querySelector("label input").checked = false;
        }
      });

      min.click();
      max.click();
    }
    else {
      const removePriceRange = document.querySelector("#remove-price-range");
      removePriceRange.click();
    }
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  setEvents() {
    this.selectors.forEach((selector) => {
      selector.addEventListener("click", this.onRangeClick.bind(this));
    });
  }

  createNoUiSlider() {
    noUiSlider.create(this.slider, {
        start: this.currentValue,
        step: 1,
        connect: true,
        range: {
            'min': this.min,
            '50%': this.max / 2,
            'max': this.max
        },
        format: {
            decimals: 2,
            thousand: ',',
            to: value => value,
            from: value => Number(value.replace(',-', ''))
        },
        pips: {
            mode: 'range',
            density: 5,
            start: 0,
            format: wNumb({
                decimals: 0,
                prefix: this.currencySymbol
            })
        }
    });
  }

  setEventsSlider() {
    this.slider.noUiSlider.on('update', (values, index) => {
      const input = index === 0 ? this.minInput : this.maxInput;
      input.value = Math.round(values[index]);
    });

    this.slider.noUiSlider.on('change', () => {
      this.setMinAndMaxValues();
      this.closest('form').submit();
    });

    const slider = this.slider.noUiSlider;
    this.minInput.addEventListener('change', function () {
      slider.set([this.value, null]);
    });
    this.maxInput.addEventListener('change', function () {
      slider.set([null, this.value]);
    });
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");
    form.onActiveFilterClick(event);
  }
}

customElements.define("facet-remove", FacetRemove);

/* Collection Grid Switcher */
class GridView extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector("[js-grid-view='button']");

    const defaultLayout = this.button.dataset.layout;
    const previouslySelectedLayout = sessionStorage.getItem("grid-view") || defaultLayout;

    document.getElementById("product-grid").dataset.layout = previouslySelectedLayout;
    this.button.dataset.layout = previouslySelectedLayout; // Ensure button reflects the saved layout

    if (previouslySelectedLayout !== defaultLayout) {
      this.button.classList.add("expanded");
    }

    this.button.addEventListener("click", this.onButtonClick.bind(this));
  }

  onButtonClick(event) {
    event.preventDefault();
    const productGrid = document.getElementById("product-grid");
    const currentLayout = productGrid.dataset.layout;
    const newLayout = currentLayout === "condensed" ? "expanded" : "condensed";

    this.toggleLayout(newLayout);
  }

  toggleLayout(newLayout) {
    const productGrid = document.getElementById("product-grid");

    if (newLayout === "expanded") {
      this.button.classList.add("expanded");
    } else {
      this.button.classList.remove("expanded");
    }

    productGrid.dataset.layout = newLayout;
    this.button.dataset.layout = newLayout; // Update button's dataset
    sessionStorage.setItem("grid-view", newLayout);
  }
}

customElements.define("grid-view", GridView);
